export enum B2bActivityEvent {
  JobOpeningSaved = 'job_opening_saved',
  JobOpeningClosed = 'job_opening_closed',
  ApplicantDecisionMade = 'applicant_decision_made',
  ContractSubmitted = 'contract_submitted',
  ApplicantCommentChanged = 'applicant_comment_changed',
  DocumentDownloaded = 'document_downloaded',
  StudyYearPlanRequested = 'study_year_plan_requested',
  SupportTicketCreated = 'support_ticket_created',
  SupportTicketClosed = 'support_ticket_closed',
  EmployeeChanged = 'employee_changed',
  SettingsSaved = 'settings_saved',
  ConsentChanged = 'consent_changed',
  CompanySwitched = 'company_switched',
  CompanyInvitationAnswered = 'company_invitation_answered',
  ListFiltered = 'list_filtered',
  ItemOpened = 'item_opened',
  FeedbackSubmitted = 'feedback_submitted',
}
